import { AdsView } from '@/views/Ads/Ads.view';
import { withPreRenderSettings } from '@/utils/hocs';
import { AdView } from '@/views/Ads/Ad.view';
import { EditAdView } from '@/views/Ads/EditAd.view';
import { getSeoFullData } from '@/api/helpers/seo.helpers';
import { useAdPageType } from '@/hooks/useAdPageType/useAdPageType';
import { getServerAdDetails } from '@/api/helpers/ad.helpers';
import { AdDetails } from '@/api/types/ads.types';
import { ServerDataProvider } from '@/contexts';

interface Props {
  adDetails: AdDetails | null;
}

function AdsPage({ adDetails }: Props) {
  const { isSinglePage, isEditPage } = useAdPageType();

  if (isEditPage) {
    return <EditAdView />;
  }

  if (isSinglePage) {
    return (
      <ServerDataProvider adDetails={adDetails}>
        <AdView />
      </ServerDataProvider>
    );
  }

  return <AdsView />;
}

AdsPage.getInitialProps = withPreRenderSettings(async (context, client) => {
  const seoFullData = await getSeoFullData(client, context);
  const { adDetails } = await getServerAdDetails(client, context);

  return {
    seoFullData: seoFullData ?? null,
    adDetails: adDetails ?? null,
  };
});

export default AdsPage;
